import { render, staticRenderFns } from "./decoration-document-info.vue?vue&type=template&id=358fd209&scoped=true&"
import script from "./decoration-document-info.vue?vue&type=script&lang=js&"
export * from "./decoration-document-info.vue?vue&type=script&lang=js&"
import style0 from "./decoration-document-info.vue?vue&type=style&index=0&id=358fd209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358fd209",
  null
  
)

export default component.exports